(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/utils/error-utils.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/utils/error-utils.js');

'use strict';

const logger = svs.core.log.getLogger('accountservices:authenticate');
const {
  ErrorTypes
} = svs.accountservices.authenticate.definitions;
function getFrejaError(errorCode, xhr, frServerSide) {
  let type;
  let message;
  switch (errorCode) {
    case 1:
      type = ErrorTypes.GENERAL;
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      break;
    case 16:
      type = ErrorTypes.FREJA_NEW_CUSTOMER;
      message = 'För att bli kund på Svenska Spel Sport & Casino AB så måste BankID användas';
      break;
    case 22:
      type = ErrorTypes.SPELPAUS_DOWN;
      message = 'Ups! Vår slagning mot Spelpaus.se för att se om du är spelpausad eller ej gav inget svar. Vänligen försök igen. Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
      break;
    case 71:
      type = ErrorTypes.TOKEN_EXPIRED;
      logger.info("Freja logintoken was created ".concat(frServerSide ? 'serverside' : 'clientside'));
      message = 'Det har gått för lång tid, var vänlig försök igen.';
      break;
    default:
      type = ErrorTypes.UNHANDLED;
      logger.error("Unhandled freja login error code: ".concat(errorCode), xhr);
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
  }
  return {
    type,
    message,
    xhr
  };
}
function getBankIDError(errorCode, xhr, frServerSide) {
  let type;
  let message;
  switch (errorCode) {
    case 1:
      type = ErrorTypes.GENERAL;
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      break;
    case 22:
      type = ErrorTypes.SPELPAUS_DOWN;
      message = 'Ups! Vår slagning mot Spelpaus.se för att se om du är spelpausad eller ej gav inget svar. Vänligen försök igen. Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
      break;
    case 41:
      type = ErrorTypes.GENERAL_BANKID;
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      break;
    case 42:
      logger.info("Invalid BankID logintoken was created ".concat(frServerSide ? 'serverside' : 'clientside'));
      type = ErrorTypes.INVALID_TOKEN;
      message = 'Det har gått för lång tid, var vänlig försök igen.';
      break;
    case 44:
      type = ErrorTypes.BANKID_UPDATE_APP;
      message = 'Det går inte att logga in just nu, prova att uppdatera BankID appen.';
      break;
    case 45:
      type = ErrorTypes.BANKID_UPDATE_ID;
      message = 'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank';
      break;
    case 47:
      type = ErrorTypes.CANNOT_LOGIN;
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      break;
    case 49:
      type = ErrorTypes.TOKEN_EXPIRED;
      logger.info("Expired BankID logintoken was created ".concat(frServerSide ? 'serverside' : 'clientside'));
      message = 'Det har gått för lång tid, var vänlig försök igen.';
      break;
    case 50:
      type = ErrorTypes.LOGIN_CANCELLED;
      message = 'Inloggningen avbruten, var vänlig försök igen.';
      break;
    case 51:
    case 52:
      type = ErrorTypes.LOGIN_USER_ABORTED;
      break;
    case 55:
      type = ErrorTypes.CANNOT_LOGIN;
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      break;
    case 56:
      logger.info("Invalid BankID logintoken was created ".concat(frServerSide ? 'serverside' : 'clientside'));
      type = ErrorTypes.BANKID_APP_NOT_RESPONDING;
      message = 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din internetbank. Försök sedan igen.';
      break;
    case 408:
      logger.info('BankID request timeout');
      type = ErrorTypes.GENERAL_BANKID;
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      break;
    default:
      type = ErrorTypes.UNHANDLED;
      logger.error("Unhandled bankid login error code: ".concat(errorCode), xhr);
      message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
  }
  return {
    type,
    message,
    xhr
  };
}
svs.accountservices.authenticate.utils.error = {
  getFrejaError,
  getBankIDError
};

 })(window);